//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import Filters from './DashboardFilters.vue';
import SystemStatus from './DashboardSystemStatus.vue';
import GrossProfit from './DashboardGrossProfit.vue';
import P2P from './DashboardP2P.vue';
import Users from './DashboardUsers.vue';
import Card from './DashboardCard.vue';
import constant from '~/const';

export default {
  components: {
    Filters,
    SystemStatus,
    GrossProfit,
    P2P,
    Users,
    Card,
  },

  data() {
    return {
      loader: false,
      constant,
      transactions: [],
      statusesForData: [
        { id: 0, caption: 'Awaiting confirmation' },
        { id: 1, caption: 'Processing' },
        { id: 5, caption: 'Admin check' },
        { id: 7, caption: 'In Queue' },
        { id: 8, caption: 'Awaiting manual check' },
        { id: 10, caption: 'Admin processing' },
        { id: 11, caption: 'Need contact support' },
      ],
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),

    ...mapState('dashboard', [
      'financeStatus',
      'grossProfitFull',
      'usersStats',
      'transactionStats',
      'additionalData',
      'p2pStatistic',
    ]),

    totalVerificationRequests() {
      const { usersStats } = this;
      if (usersStats.verificationRequest) {
        const verification = usersStats.verificationRequest;
        return verification.total - (verification.rejected + verification.confirmed);
      }
      return 0;
    },

    usersWithWarnings() {
      const { usersStats } = this;
      return usersStats.usersWithWarnings || 0;
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralProgress',
    ]),
    ...mapActions('dashboard', {
      loadFinanceStatusAction: 'loadFinanceStatus',
      loadGrossProfitFullAction: 'loadGrossProfitFull',
      loadUsersStatsAction: 'loadUsersStats',
      loadTransactionStatsAction: 'loadTransactionStats',
      loadP2pStatisticAction: 'loadP2pStatistic',
    }),
    ...mapActions('transactionsHistoryOld', {
      getTransactions: 'getTransactionsHistory',
    }),

    async getTransactionsStats() {
      await Promise.all(this.statusesForData.map(async (status) => {
        const response = await this.getTransactions({ transactionStatusList: [status.id] });
        this.transactions.push({ id: status.id, total: response.total });
      }));
    },

    async loadData() {
      this.setGeneralProgress(true);
      this.loader = true;
      await Promise.allSettled([
        this.loadFinanceStatusAction(),
        this.loadGrossProfitFullAction(),
        this.loadUsersStatsAction(),
        this.loadTransactionStatsAction(),
        this.loadP2pStatisticAction(),
        this.getTransactionsStats(),
      ]);
      this.setGeneralProgress(false);
      this.loader = false;
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData();
    },
  },
};
